import React, { FC } from 'react';

import {
  List, ListItem, Typography, TextField, Button, createStyles, makeStyles, Box,
} from '@material-ui/core';

import * as yup from 'yup';
import { useForm, OnSubmit } from 'react-hook-form';

interface PricesheeteditorFormProps {
    name: string,
    baseMarkup: number,
    scope: string,
    scopeId: string
}

const schema = yup.object().shape({
  name: yup.string().required(),
  baseMarkup: yup
    .number()
    .required()
    .positive()
    .integer(),
  scope: yup.string().required(),
  scopeId: yup.string().required(),
});

const useStyles = makeStyles(() => createStyles({
  label: {
    width: '8rem',
  },
  textField: {
    width: '20rem',
  },
}));

interface PricesheetBasicsEditorProps {
  onSubmit: OnSubmit<PricesheeteditorFormProps>
  buttonText: string
}

const PricesheetBasicsEditor: FC<PricesheetBasicsEditorProps> = (props) => {
  const classes = useStyles();
  const { handleSubmit, register, errors } = useForm<PricesheeteditorFormProps>({
    validationSchema: schema,
  });
  const { onSubmit, buttonText } = props;

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <List>
        <ListItem>
          <Typography className={classes.label}>Name</Typography>
          <TextField
            required
            id="name"
            name="name"
            className={classes.textField}
            inputRef={register}
          />
          {errors.name && <Typography>{errors.name}</Typography>}
        </ListItem>
        <ListItem>
          <Typography className={classes.label}>Base Markup</Typography>
          <TextField
            required
            id="baseMarkup"
            name="baseMarkup"
            className={classes.textField}
            inputRef={register}
          />
          {errors.baseMarkup && <Typography>{errors.baseMarkup}</Typography>}
        </ListItem>
        <ListItem>
          <Typography className={classes.label}>Scope</Typography>
          <TextField
            required
            id="scope"
            name="scope"
            className={classes.textField}
            inputRef={register}
          />
          {errors.scope && <Typography>{errors.scope}</Typography>}
        </ListItem>
        <ListItem>
          <Typography className={classes.label}>Scope Id</Typography>
          <TextField
            required
            id="scopeId"
            name="scopeId"
            className={classes.textField}
            inputRef={register}
          />
          {errors.scopeId && <Typography>{errors.scopeId}</Typography>}
        </ListItem>
      </List>
      <Box style={{ textAlign: 'center', paddingTop: '2rem' }}>
        <Button type="submit"><Typography variant="h6">{buttonText}</Typography></Button>
      </Box>
    </form>
  );
};

export default PricesheetBasicsEditor;
